export default __webpack_public_path__ + "static/media/S1xCLUE2.cc1821d6.jpg";